<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row mb-5">
        <div class="col-md-4">
          <div class="card card-xl-stretch">
            <div class="card-body d-flex flex-column">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center">
                  <h1 class="fw-bold flex-grow-1">
                    {{ totalPatientCount || 0 }}
                  </h1>
                  <div class="symbol symbol-50px">
                    <span class="symbol-label bg-light">
                      <i class="fa-solid fa-users"></i>
                    </span>
                  </div>
                </div>
                <p class="text-gray-900 fw-bold text-hover-primary fs-4">
                  {{ "totalPatients" | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <div class="card card-xl-stretch">
            <div class="card-body d-flex flex-column">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center">
                  <h1 class="fw-bold flex-grow-1">
                    {{ totalECGCount || 0 }}
                  </h1>
                  <div class="symbol symbol-50px">
                    <span class="symbol-label bg-light">
                      <i class="fa-regular fa-file-lines"></i>
                    </span>
                  </div>
                </div>
                <p class="text-gray-900 fw-bold text-hover-primary fs-4">
                  {{ "totalECG" | translate }}
                </p>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-md-4">
          <div class="card card-xl-stretch">
            <div class="card-body d-flex flex-column">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center">
                  <h1 class="fw-bold flex-grow-1">
                    {{ totalConsultationCount || 0 }}
                  </h1>
                  <div class="symbol symbol-50px">
                    <span class="symbol-label bg-light">
                      <i class="fa-regular fa-circle-check"></i>
                    </span>
                  </div>
                </div>
                <p class="text-gray-900 fw-bold text-hover-primary fs-4">
                  {{ "totalConsultations" | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
